'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _audioPlayer = require('./audioPlayer');

var _audioPlayer2 = _interopRequireDefault(_audioPlayer);

var _currentTask = require('./currentTask');

var _currentTask2 = _interopRequireDefault(_currentTask);

var _tasks = require('./tasks');

var _tasks2 = _interopRequireDefault(_tasks);

var _folders = require('./folders');

var _folders2 = _interopRequireDefault(_folders);

var _newFolder = require('./newFolder');

var _newFolder2 = _interopRequireDefault(_newFolder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cortexApp = (0, _redux.combineReducers)({
  audioPlayer: _audioPlayer2.default,
  currentTask: _currentTask2.default,
  tasks: _tasks2.default,
  folders: _folders2.default,
  newFolder: _newFolder2.default
});

exports.default = cortexApp;


//////////////////
// WEBPACK FOOTER
// ./client/reducers/index.js
// module id = 113
// module chunks = 0